import { FilterSubmitButton, useFilterFormError } from '@/components/common/Filter'
import { InputSelect, InputText } from '@/components/common/Input'
import { type CardFilterNumberPartialType, type CardFilterNumberType } from '@/defs/cardFilters'
import { NUMBER_OPERATOR_LABELS, NUMBER_OPERATORS } from '@/defs/common'

import styles from './GalleryCardFiltersFormNumber.module.scss'

type Props = {
  cardFilter: CardFilterNumberPartialType
  onUpdate: (f: CardFilterNumberPartialType) => void
}

const OPTIONS = NUMBER_OPERATORS.map((c) => ({
  label: NUMBER_OPERATOR_LABELS[c].labelLong,
  value: c,
}))

export const GalleryCardFiltersFormNumber = ({ cardFilter, onUpdate }: Props) => {
  const { number, operator } = cardFilter
  const operatorError = useFilterFormError(!operator)
  const numberError = useFilterFormError(number === undefined)

  const onUpdateOperator = (operator: CardFilterNumberType['operator']) => {
    onUpdate({ ...cardFilter, operator })
  }

  const onUpdateNumber = (numberInput: string) => {
    const number = parseInt(numberInput)
    onUpdate({ ...cardFilter, number: !isNaN(number) ? number : undefined })
  }

  return (
    <div className={styles.container}>
      <div className={styles.operator}>
        <InputSelect
          borderColor={operatorError.warn ? 'warning' : undefined}
          colorScheme='muted'
          onSelect={onUpdateOperator}
          options={OPTIONS}
          placeholder='Choose operator'
          value={operator}
          wiggle={operatorError.wiggle}
        />
      </div>
      <div className={styles.number}>
        <InputText
          autoFocus
          borderColor={numberError.warn ? 'warning' : undefined}
          colorScheme='muted'
          min={0}
          onChange={onUpdateNumber}
          placeholder='#'
          type='number'
          value={number}
          wiggle={numberError.wiggle}
        />
      </div>
      <FilterSubmitButton />
    </div>
  )
}
